import boonePic from "@/public/images/artists/boone.png";
import { Artist } from "@/types/types";

export const boone = {
  id: "251",
  name: "Boone",
  image: boonePic,
  description: `Boone's delivery is dynamic and elastic, shifting fluidly from clipped, percussive bursts to loose, melodic phrasing. His enunciation is sharp — consonants pop, and vowels stretch or snap with the mood.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fboone-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Dance", "Hip Hop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 42,
        high: 65,
      },
      sweetSpot: 52,
    },
  },
} as const satisfies Artist;
